module.exports = __webpack_public_path__ + "img/voice_keep.981beb97.png";